

export const API_PERMISSIONS = {

    SUPER_USER: ["GOD_MODE", "SUPER_ADMIN"],

    EXTRA: ["IMPORT", "EXPORT"],

    ACTIONS: {
        LIST: { suffix: "/list", permission: "LIST" },
        CREATE: { suffix: "/create", permission: "CREATE" },
        UPDATE: { suffix: "/update", permission: "UPDATE" },
        REMOVE: { suffix: "/remove", permission: "REMOVE" },
        DETAIL: { suffix: "/detail/:id", permission: "DETAIL" },
        ARCHIVE: { suffix: "/archive", permission: "ARCHIVE" },
        RESTORE: { suffix: "/restore", permission: "RESTORE" },
        ARCHIVED: { suffix: "/archived", permission: "LIST_ARCHIVED" },
        BULK_CREATE: { suffix: "/bulk/create", permission: "BULK_CREATE" },
        BULK_ARCHIVE: { suffix: "/bulk/archive", permission: "BULK_ARCHIVE" },
        BULK_RESTORE: { suffix: "/bulk/restore", permission: "BULK_RESTORE" },
        BULK_REMOVE_REQUEST: { suffix: "/bulk/remove/request", permission: "BULK_REMOVE" },
        BULK_REMOVE_CONFIRM: { suffix: "/bulk/remove/confirm", permission: "BULK_REMOVE" },
    }
};